export const APP_GLOBAL_CONFIG = {
  NAME: 'Clésame',
}
